import React from 'react'
import { MainDiv, NumberDiv, StudentDiv, StyledDivision } from './style'

const PreviewScreenCard = ({ elgibileCount }) => {
  return (
    <MainDiv>
      <NumberDiv> {elgibileCount} </NumberDiv>
      <StudentDiv>Students</StudentDiv>

      <StyledDivision>
        This job will be floated to these students.
      </StyledDivision>
    </MainDiv>
  )
}
export default PreviewScreenCard
